import { types, actions } from './requests'
export const GETMOLD_TYPES = {
    ...types('GETMOLD'),
}
export const GETMOLD_ACTIONS = {
    ...actions('GETMOLD'),
}